import { Button } from "./Button";
import {
  DEFAULT_PLAYER_COLOR,
  GUEST_PLAYER_COLOR,
  DEFAULT_PLAYER_EMOJI,
  GUEST_PLAYER_EMOJI,
} from "../constants";
import { formatPlayerName } from "../utils/helpers";
import type { PlayerInfo } from "../types/game";

interface GameOverScreenProps {
  players: PlayerInfo[];
  currentPlayerId: string;
  onLeaveGame: () => void;
}

export function GameOverScreen({
  players,
  currentPlayerId,
  onLeaveGame,
}: GameOverScreenProps) {
  return (
    <div className="glass rounded-lg p-6 border-2 border-green-400 mt-6">
      <div className="text-center mb-6">
        <h2 className="font-display text-4xl font-bold text-green-400 mb-2">
          Game Over!
        </h2>
        <p className="text-gray-300">Final Scores</p>
      </div>
      <div className="space-y-3 mb-6">
        {[...players]
          .sort((a, b) => b.score - a.score)
          .map((player, idx) => (
            <div
              key={player.player_id}
              className={`flex items-center justify-between p-3 rounded-lg ${
                idx === 0
                  ? "bg-yellow-500/30 border border-yellow-400"
                  : "bg-white/10"
              }`}
            >
              <div className="flex items-center gap-3">
                <span className="text-2xl font-bold text-gray-400">
                  #{idx + 1}
                </span>
                <div
                  className="h-10 w-10 rounded-lg flex items-center justify-center font-bold text-white text-2xl"
                  style={{
                    backgroundColor: player.is_guest
                      ? GUEST_PLAYER_COLOR
                      : player.theme_primary_color || DEFAULT_PLAYER_COLOR,
                  }}
                >
                  {player.profile_emoji ||
                    (player.is_guest
                      ? GUEST_PLAYER_EMOJI
                      : DEFAULT_PLAYER_EMOJI)}
                </div>
                <span className="font-medium">
                  {formatPlayerName(
                    player.display_name,
                    player.player_id === currentPlayerId,
                  )}
                  {idx === 0 && " 🏆"}
                </span>
              </div>
              <span className="text-2xl font-bold">{player.score} pts</span>
            </div>
          ))}
      </div>
      <div className="flex gap-4">
        <Button variant="primary" onClick={onLeaveGame} className="flex-1">
          Leave Game
        </Button>
      </div>
    </div>
  );
}
